import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSectionA } from '../components/sections/ProblemSectionA';
import { CostComparisonSection } from '../components/sections/CostComparisonSection';
import { CaseStudiesSection } from '../components/sections/CaseStudiesSection';
import { FunnelSection } from '../components/sections/FunnelSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { RevenueProjectionSection } from '../components/sections/RevenueProjectionSection';
import { RepsOverTimeSection } from '../components/sections/RepsOverTimeSection';
import { RecruitingCostCalculator } from '../components/sections/RecruitingCostCalculator';
import { AuthoritySection } from '../components/sections/AuthoritySection';
import { ObjectionSection } from '../components/sections/ObjectionSection';
import { GuaranteeSection } from '../components/sections/GuaranteeSection';
import { FooterSection } from '../components/sections/FooterSection';
export function LandingPage() {
  return <div className="w-full min-h-screen font-sans" data-id="element-813">
      <HeroSection data-id="element-814" />
      <ProblemSectionA data-id="element-815" />
      <CostComparisonSection data-id="element-816" />
      <CaseStudiesSection data-id="element-817" />
      <FunnelSection data-id="element-818" />
      <HowItWorksSection data-id="element-819" />
      <RevenueProjectionSection data-id="element-820" />
      <RepsOverTimeSection data-id="element-821" />
      <RecruitingCostCalculator data-id="element-822" />
      <AuthoritySection data-id="element-823" />
      <ObjectionSection data-id="element-824" />
      <GuaranteeSection data-id="element-825" />
      <FooterSection data-id="element-826" />
    </div>;
}